export function isChessRussianClub(clubId?: string) {
  return clubId === '777' || clubId === '201' /* тестовый открытый клуб */;
}
